import getAxiosBasicUrlAndHeader from 'api/helpers/getAxiosBasicUrlAndHeader'
import axios from 'axios'

/**
 * requires user to have group code 6A
 * @param {Array} ids
 * @param {*} userInputForm
 * @param {*} session
 * @returns Promise success or fail message
 */
const alertAcknowledgeService = async (ids, userInputForm, session) => {
  const id = ids[0]
  const { notes } = userInputForm

  const jsonBody = {
    stationCode: id.stationCode,
    blockIndex: id.blockIndex,
    bessStatusCode: id.bessStatusCode,
    startTimestamp: id.startTimestamp.epochMillis,
    notes: notes,
  }

  const { apiUrl, axiosHeader } = getAxiosBasicUrlAndHeader(session)

  return await axios
    .put(`${apiUrl}alerts/acknowledge`, jsonBody, axiosHeader)
    .then((res) => res.data)
}

export default alertAcknowledgeService
